import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCardApiValue, formatValue } from '../helpers';
import { checkKpiType } from '@flexo/general';

interface InformationCardContentLabelValueListProps {
  description: any[];
  overviewKpiApiData: any[];
  kpiContext: string;
  currencyFields: string[];
  id: string;
}

const InformationCardContentLabelValueList: React.FC<InformationCardContentLabelValueListProps> = ({ description, overviewKpiApiData, kpiContext, currencyFields, id }) => {
  const { t } = useTranslation();
  return (
    <span className="paragraph">
      {description.map((el, i, array) => {
        const valueObj = getCardApiValue(el?.value, overviewKpiApiData, currencyFields);
        return (
          <React.Fragment key={`${id}-label-value-list-${i}`}>
            {t(el.key)}{' '}
            {formatValue(valueObj.value, kpiContext, checkKpiType) + (valueObj?.unit || '')}
            {i < array.length - 1 ? '| ' : ''}
          </React.Fragment>
        );
      })}
    </span>
  );
};

export default InformationCardContentLabelValueList; 